import { apiInstance } from "@/utils/ApiUtil";
const baseURL = "/admin/user";

const getUsers = async (req) => {
    try {
        const response = await apiInstance.get(baseURL + "/all", {
            params: {
                search: req.search,
                sort: req.sort,
                page: req.page,
                limit: req.limit,
            }
        });
        return response.data.success ? response.data : [];
    } catch (error) {
        return [];
    }
};

const getStats = async () => {
    try {
        const response = await apiInstance.get(baseURL + "/stats");
        return response.data.success ? response.data.stats : [];
    } catch (error) {
        return [];
    }
};

const updateUser = async (req) => {
    try {
        const response = await apiInstance.put(baseURL + "/update", req);
        return response.data.success;
    } catch (error) {
        return false;
    }
};

const AdminUserService = {
    getUsers,
    getStats,
    updateUser
}

export default AdminUserService;